'use no memo';

import { useQueryActiveUser } from '@ll-platform/frontend/core/auth/async/hooks';
import type { ActiveUserProfile } from '@ll-platform/frontend/core/auth/types';
import { getUserJwt } from '@ll-platform/frontend/core/auth/utils/localStorage';

type UseUserReturn =
  | {
      isLoading: boolean;
      isAuthorized: true;
      activeUser: ActiveUserProfile;
    }
  | {
      isLoading: boolean;
      isAuthorized: false;
      activeUser: undefined;
    };

export function useUser(): UseUserReturn {
  'use no memo';

  const token = getUserJwt();

  const activeUserQuery = useQueryActiveUser(
    {},
    {
      enabled: !!token,
      meta: {
        supressErrorToast: true,
      },
    },
  );
  const activeUser = activeUserQuery.data;

  if (activeUser) {
    return {
      isLoading: false,
      isAuthorized: true,
      activeUser,
    };
  } else {
    return {
      isLoading: activeUserQuery.isLoading,
      isAuthorized: false,
      activeUser: undefined,
    };
  }
}
